export const SLICE_NAME = 'adp';
